// extracted by mini-css-extract-plugin
export default {"container":"Links_container__oisDE","iconContainer":"Links_iconContainer__skpg-","icon":"Links_icon__RWUHL"};